import { useEffect } from 'react';

/**
 * Un unico listener de scroll para todo el sitio, limitado a un frame.
 * Escribe variables CSS en <html> en vez de provocar renders de React:
 *
 *   --avance      0 -> 1, el progreso de lectura (la linea de arriba)
 *   --hero-y      desplazamiento suave de la foto del hero
 *   [data-pasado-hero]  "si" cuando ya se dejo atras la portada
 */
export default function useScrollDriver() {
  useEffect(() => {
    const raiz = document.documentElement;
    const quieto = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    let frame = 0;

    const medir = () => {
      frame = 0;
      const y = window.scrollY || 0;
      const alto = Math.max(1, raiz.scrollHeight - window.innerHeight);
      raiz.style.setProperty('--avance', String(Math.min(1, y / alto)));
      raiz.dataset.pasadoHero = y > window.innerHeight * 0.65 ? 'si' : 'no';
      if (!quieto) {
        raiz.style.setProperty('--hero-y', `${Math.min(y * 0.15, 120)}px`);
      }
    };

    const alScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(medir);
    };

    medir();
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', alScroll);
      window.removeEventListener('resize', alScroll);
    };
  }, []);
}
